import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useErrorMessage } from '@/components/error';
type CardErrorProps = {
  error: unknown;
};

/** A failed request as one sentence in an empty card, so it doesn't read as an empty result. */
const CardError = t0 => {
  const $ = _c(2);
  const {
    error
  } = t0;
  const t1 = useErrorMessage(error);
  let t2;
  if ($[0] !== t1) {
    t2 = <Card.Root><Card.Empty role="status">{t1}</Card.Empty></Card.Root>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default CardError;